{
  "version": 1,
  "asset_id": "0804d564-b804-459b-8048-edbbbca15c3b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0804d564-b804-459b-8048-edbbbca15c3b/mark-384.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0804d564-b804-459b-8048-edbbbca15c3b/mark-384.png",
  "original_filename": "mark-384.png",
  "size": 41492,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:31Z"
}
